import { Property } from 'csstype';

export type FontStyle = Property.FontStyle;

enum FontStyles {
  normal = 'normal'
}

export default FontStyles;
